import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainPT() {
  const articleData = {
    title: 'Por que algumas pessoas nos deixam esgotados? (A IA explica)',
    description: 'Sentindo-se emocionalmente esgotado por textos? Saiba como a IA do Toxic Detector detecta comunicação unilateral e padrões sutis de esgotamento emocional em seus relacionamentos.',
    slug: 'emotional-drain-relationships-ai',
    publishDate: '2025-09-03',
    author: 'Editorial Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'O que é esgotamento emocional em relacionamentos?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'O esgotamento emocional acontece quando as interações com alguém deixam você constantemente cansado, frustrado ou culpado, muitas vezes devido à comunicação unilateral ou manipuladora.'
      }
    }, {
      '@type': 'Question',
      name: 'Como as mensagens de texto podem causar esgotamento emocional?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Mensagens unilaterais repetidas, culpa, engajamento inconsistente ou críticas sutis podem deixar você exausto, mesmo sem grandes conflitos.'
      }
    }, {
      '@type': 'Question',
      name: 'A IA pode detectar quem está drenando minha energia emocional?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sim. O Toxic Detector analisa padrões de texto, tom e engajamento para destacar comportamentos unilaterais, manipuladores ou desgastantes instantaneamente.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/pt/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Link copiado para a área de transferência!');
    }
  };
  return <>
      <MetaTags title="Por que algumas pessoas nos deixam esgotados? — IA explica o esgotamento emocional | ToxicDetector" description="Sentindo-se emocionalmente esgotado por textos? Saiba como a IA do Toxic Detector detecta comunicação unilateral e padrões sutis de esgotamento emocional." keywords="esgotamento emocional em relacionamentos, padrões de texto unilaterais, vampiros de energia, análise emocional IA" canonical={`https://toxicdetector.com/pt/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/dA7JvMmr79gFQy3nZ9PyWw/file_00000000ee5472468a16f1060b3742e2.png" schema={[faqSchema, articleSchema]} data-id="element-8923" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-8924">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-8925">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-8926">
            <div className="flex items-center justify-between" data-id="element-8927">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-8928">
                <span className="text-2xl" data-id="element-8929">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-8930">
                  ToxicDetector
                </span>
              </Link>
              <div className="flex items-center gap-3" data-id="element-8931">
                <Link to="/signup" className="hidden sm:inline-block bg-red-600 text-white px-5 py-2.5 rounded-lg font-semibold text-sm hover:bg-red-700 transition-all shadow-sm hover:shadow-md" data-id="element-8932">
                  Scan Grátis
                </Link>
                <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Compartilhar artigo" data-id="element-8933">
                  <Share2 size={20} className="text-gray-600" data-id="element-8934" />
                </button>
              </div>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-8935">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-8936">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-8937" />
            Voltar ao Início
          </Link>

          <header className="mb-16" data-id="element-8938">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-8939">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-8940">
              <time dateTime={articleData.publishDate} data-id="element-8941">
                {new Date(articleData.publishDate).toLocaleDateString('pt-BR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-8942">•</span>
              <span data-id="element-8943">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-16" data-id="element-8944">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ajgMhQjEKnfJfWgPd5sqFq/1763122862210.jpg" alt="IA analisando padrões de esgotamento emocional em mensagens de texto" className="w-full rounded-2xl shadow-lg" data-id="element-8945" />
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 mb-16" data-id="element-8946">
            <h2 className="font-bold text-xl mb-6 text-gray-900" data-id="element-8947">Índice</h2>
            <ol className="space-y-3.5 text-base list-decimal list-inside" data-id="element-8948">
              <li data-id="element-8949">
                <a href="#always-something-wrong" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8950">
                  O amigo "Sempre tem algo errado"
                </a>
              </li>
              <li data-id="element-8951">
                <a href="#only-when-they-need" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8952">
                  A pessoa que só manda mensagem quando precisa de algo
                </a>
              </li>
              <li data-id="element-8953">
                <a href="#dry-texting" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8954">
                  O "Dry-Texter" sem emoção
                </a>
              </li>
              <li data-id="element-8955">
                <a href="#ghost-return" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8956">
                  O artista do Ghost & Return
                </a>
              </li>
              <li data-id="element-8957">
                <a href="#guilt-tripper" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8958">
                  O culpabilizador sutil
                </a>
              </li>
              <li data-id="element-8959">
                <a href="#faux-supporter" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8960">
                  O falso apoiador
                </a>
              </li>
              <li data-id="element-8961">
                <a href="#healthy-toxic-combo" className="text-gray-700 hover:text-red-600 transition-colors font-medium" data-id="element-8962">
                  O combo "Saudável-Tóxico"
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-8963">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-8964">
              Você já mandou mensagem para alguém e se sentiu cansado, irritado
              ou estranhamente culpado depois, mesmo que a conversa não tenha
              sido uma briga? Isso é{' '}
              <strong className="text-gray-900" data-id="element-8965">
                esgotamento emocional em relacionamentos
              </strong>
              , e é mais comum do que você pensa.
            </p>
            <p className="mb-16 text-lg leading-relaxed text-gray-600" data-id="element-8966">
              Esses são{' '}
              <strong className="text-gray-900" data-id="element-8967">
                padrões de texto unilaterais
              </strong>{' '}
              e manipulação sutil. Nossa{' '}
              <strong className="text-gray-900" data-id="element-8968">análise de IA</strong> lê esses
              padrões instantaneamente.
            </p>

            <section id="always-something-wrong" className="mb-16" data-id="element-8969">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8970">
                1️⃣ O amigo "Sempre tem algo errado"
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8971">
                Você olha para o seu telefone e sente instantaneamente:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8972">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8973">
                  "Ai meu Deus... o que agora?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8974">
                Cada mensagem é estresse, caos ou reclamações. A IA sinaliza
                isso como uma{' '}
                <strong className="text-gray-900" data-id="element-8975">
                  carga emocional unilateral
                </strong>
                .
              </p>
            </section>

            <section id="only-when-they-need" className="mb-16" data-id="element-8976">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8977">
                2️⃣ A pessoa que só manda mensagem quando precisa de algo
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-8978">
                <p className="mb-4 text-lg text-gray-700" data-id="element-8979">
                  <strong className="text-gray-900" data-id="element-8980">Nunca:</strong> "Como você
                  está?"
                </p>
                <p className="text-lg text-gray-700" data-id="element-8981">
                  <strong className="text-gray-900" data-id="element-8982">Sempre:</strong> "Você
                  pode...?"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8983">
                A IA detecta isso como{' '}
                <strong className="text-gray-900" data-id="element-8984">
                  comunicação transacional
                </strong>
                .
              </p>
            </section>

            <section id="dry-texting" className="mb-16" data-id="element-8985">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8986">
                3️⃣ O "Dry-Texter" sem emoção
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8987">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8988">
                  "ok."
                  <br data-id="element-8989" />
                  "K."
                  <br data-id="element-8990" />
                  "👍"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-8991">
                A IA captura esses{' '}
                <strong className="text-gray-900" data-id="element-8992">sinais de desconexão</strong>{' '}
                instantaneamente.
              </p>
            </section>

            <section id="ghost-return" className="mb-16" data-id="element-8993">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8994">
                4️⃣ O artista do Ghost & Return
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8995">
                Desaparece por 3 semanas. Volta como:
              </p>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-8996">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-8997">
                  "oiii 😁"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8998">
                A IA sinaliza isso como{' '}
                <strong className="text-gray-900" data-id="element-8999">
                  engajamento inconsistente
                </strong>
                .
              </p>
            </section>

            <section id="guilt-tripper" className="mb-16" data-id="element-9000">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-9001">
                5️⃣ O culpabilizador sutil
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-9002">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-9003">
                  "Acho que vou sozinho então..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-9004">
                A IA marca isso como{' '}
                <strong className="text-gray-900" data-id="element-9005">manipulação passiva</strong>.
              </p>
            </section>

            <section id="faux-supporter" className="mb-16" data-id="element-9006">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-9007">
                6️⃣ O falso apoiador
              </h2>
              <div className="bg-red-50 border-l-4 border-red-600 p-8 mb-8 rounded-r-xl" data-id="element-9008">
                <p className="italic text-gray-900 text-xl font-medium" data-id="element-9009">
                  "Digo, você tende a reagir exageradamente às vezes."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-9010">
                A IA detecta{' '}
                <strong className="text-gray-900" data-id="element-9011">crítica mascarada</strong>.
              </p>
            </section>

            <section id="healthy-toxic-combo" className="mb-16" data-id="element-9012">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-9013">
                7️⃣ O combo "Saudável-Tóxico"
              </h2>
              <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 mb-8" data-id="element-9014">
                <p className="mb-4 text-lg text-gray-700" data-id="element-9015">
                  Alguns dias quente. Alguns dias frio.
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600 mb-8" data-id="element-9016">
                A IA rotula esse padrão como{' '}
                <strong className="text-gray-900" data-id="element-9017">
                  ritmo emocional instável
                </strong>
                .
              </p>
            </section>

            <section className="mb-16" data-id="element-9018">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-9019">
                Por que isso importa
              </h2>
              <div className="bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl p-10 mb-10 border border-red-100" data-id="element-9020">
                <p className="font-bold mb-8 text-2xl text-gray-900" data-id="element-9021">
                  Uma vez que você vê o padrão, você pode:
                </p>
                <ul className="space-y-5" data-id="element-9022">
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-9023">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-9024">
                      ✓
                    </span>
                    <span data-id="element-9025">Proteger sua energia</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-9026">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-9027">
                      ✓
                    </span>
                    <span data-id="element-9028">Estabelecer limites</span>
                  </li>
                  <li className="flex items-start gap-4 text-lg text-gray-700" data-id="element-9029">
                    <span className="text-red-600 font-bold text-xl flex-shrink-0" data-id="element-9030">
                      ✓
                    </span>
                    <span data-id="element-9031">Parar de se sentir culpado</span>
                  </li>
                </ul>
              </div>
            </section>

            <section id="faq" className="mb-20" data-id="element-9032">
              <h2 className="text-4xl font-bold mb-10 tracking-tight text-gray-900" data-id="element-9033">
                Perguntas Frequentes
              </h2>
              <div className="space-y-5" data-id="element-9034">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-9035">
                    <h3 className="font-bold text-xl mb-4 text-gray-900" data-id="element-9036">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-lg" data-id="element-9037">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl" data-id="element-9038">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-9039">
              😮‍💨 Pare de se sentir esgotado.
              <br data-id="element-9040" />
              Comece a ver com clareza.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-9041">
              Pare de adivinhar. Envie seus textos para o Toxic Detector e
              obtenha uma pontuação de toxicidade instantânea.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 mb-10 border border-white/20" data-id="element-9042">
              <p className="font-bold text-2xl" data-id="element-9043">
                "⚠️ Esgotamento Emocional: Alto. Comunicação unilateral
                detectada."
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-9044">
              Escaneie seus chats agora →
            </Link>
          </div>

          <div className="mt-20" data-id="element-9045">
            <RelatedBlogPosts posts={[{
            title: 'Por que algumas pessoas nos deixam esgotados? Parte 2',
            description: 'Mais padrões sutis que drenam sua energia, incluindo sobre-explicação e sabe-tudo.',
            slug: 'emotional-drain-part-2',
            emoji: '😭'
          }, {
            title: 'O Guia Definitivo para Textos Passivo-Agressivos',
            description: 'Detecte comportamento passivo-agressivo e manipulação oculta em mensagens de texto.',
            slug: 'ultimate-guide-passive-aggressive-texts',
            emoji: '😤'
          }]} data-id="element-9046" />
          </div>

          <div className="mt-16 text-center" data-id="element-9047">
            <button onClick={handleShare} className="inline-flex items-center gap-2 text-gray-700 hover:text-red-600 font-semibold transition-colors px-6 py-3 rounded-lg hover:bg-gray-50" data-id="element-9048">
              <Share2 size={20} data-id="element-9049" />
              Compartilhar este artigo
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-9050">
          <div className="max-w-4xl mx-auto px-6" data-id="element-9051">
            <div className="border-t border-gray-800 pt-8 text-center" data-id="element-9052">
              <p className="text-gray-400 text-sm" data-id="element-9053">
                © {new Date().getFullYear()} ToxicDetector. Todos os direitos
                reservados.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </>;
}